import { apiQuery, atsApiQuery } from '..';

export const dashboardNormalApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getTasksMetrics: builder.query({
        transformResponse: (response) => response.data,
        query: () => {
          return {
            method: 'get',
            url: `/tasks/metrics`,
          };
        },
      }),
      getScorecardTasks: builder.mutation({
        transformResponse: (response) => response,
        query: ({ params }) => {
          return {
            method: 'get',
            url: `/tasks/scorecards`,
            params,
          };
        },
      }),
      getJobApprovalTasks: builder.mutation({
        transformResponse: (response) => response,
        query: ({ params }) => {
          const newParams = { type: 'job', ...params };
          return {
            method: 'get',
            url: `/tasks/approvals`,
            params: newParams,
          };
        },
      }),
      getOfferApprovalTasks: builder.mutation({
        transformResponse: (response) => response,
        query: ({ params }) => {
          const newParams = { type: 'offer', ...params };
          return {
            method: 'get',
            url: `/tasks/approvals`,
            params: newParams,
          };
        },
      }),
      getSurveyTasks: builder.mutation({
        transformResponse: (response) => response,
        query: ({ params }) => {
          const newParams = { ...params };
          return {
            method: 'get',
            url: `/tasks/surveys`,
            params: newParams,
          };
        },
      }),
      getRequisitionApprovalTasks: builder.mutation({
        transformResponse: (response) => response,
        query: ({ params }) => {
          const newParams = { type: 'requisition', ...params };
          return {
            method: 'get',
            url: `/tasks/approvals`,
            params: newParams,
          };
        },
      }),
      getSurveyFormTemplate: builder.mutation({
        transformResponse: (response) => response,
        query: ({ surveyId }) => {
          return {
            method: 'get',
            url: `/api_ats/v1/survey_form_templates/${surveyId}`,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const dashboardApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getApplicationMetrics: builder.mutation({
        transformResponse: (response) => response,
        query: ({ params }) => {
          return {
            method: 'get',
            url: `/ats_applications/metrics`,
            params,
          };
        },
      }),

      getDashboardActivitiesMetrics: builder.mutation({
        transformResponse: (response) => response,
        query: ({ params }) => {
          return {
            method: 'get',
            url: `/ats_applications/dashboard/metrics`,
            params,
          };
        },
      }),
      getDashboardActivities: builder.mutation({
        transformResponse: (response) => response,
        query: ({ params }) => {
          return {
            method: 'get',
            url: `/ats_applications/dashboard`,
            params,
          };
        },
      }),
      getUpcomingInterviews: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ params }) => {
          return {
            method: 'get',
            url: `/ats_interviews`,
            params,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetApplicationMetricsMutation,
  useGetDashboardActivitiesMetricsMutation,
  useGetDashboardActivitiesMutation,
  useGetUpcomingInterviewsMutation,
} = dashboardApi;

export const {
  useGetTasksMetricsQuery,
  useGetScorecardTasksMutation,
  useGetJobApprovalTasksMutation,
  useGetOfferApprovalTasksMutation,
  useGetSurveyTasksMutation,
  useGetSurveyFormTemplateMutation,
  useGetRequisitionApprovalTasksMutation,
} = dashboardNormalApi;
